/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminGroupSaleListProduct,
    AdminGroupSaleListProductFromJSON,
    AdminGroupSaleListProductFromJSONTyped,
    AdminGroupSaleListProductToJSON,
} from './AdminGroupSaleListProduct';
import {
    AdminGroupSaleMarketplace,
    AdminGroupSaleMarketplaceFromJSON,
    AdminGroupSaleMarketplaceFromJSONTyped,
    AdminGroupSaleMarketplaceToJSON,
} from './AdminGroupSaleMarketplace';
import {
    AdminGroupSaleStatus,
    AdminGroupSaleStatusFromJSON,
    AdminGroupSaleStatusFromJSONTyped,
    AdminGroupSaleStatusToJSON,
} from './AdminGroupSaleStatus';

/**
 * 
 * @export
 * @interface AdminGroupSaleList
 */
export interface AdminGroupSaleList {
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleList
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleList
     */
    id: string;
    /**
     * 
     * @type {Array<AdminGroupSaleMarketplace>}
     * @memberof AdminGroupSaleList
     */
    marketplaces?: Array<AdminGroupSaleMarketplace>;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleList
     */
    name: string;
    /**
     * 
     * @type {Array<AdminGroupSaleListProduct>}
     * @memberof AdminGroupSaleList
     */
    products?: Array<AdminGroupSaleListProduct>;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleList
     */
    soldDate?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminGroupSaleList
     */
    soldPrice: number;
    /**
     * 
     * @type {AdminGroupSaleStatus}
     * @memberof AdminGroupSaleList
     */
    status: AdminGroupSaleStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminGroupSaleList
     */
    updatedAt: string;
}



export function AdminGroupSaleListFromJSON(json: any): AdminGroupSaleList {
    return AdminGroupSaleListFromJSONTyped(json, false);
}

export function AdminGroupSaleListFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminGroupSaleList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'id': json['id'],
        'marketplaces': !exists(json, 'marketplaces') ? undefined : ((json['marketplaces'] as Array<any>).map(AdminGroupSaleMarketplaceFromJSON)),
        'name': json['name'],
        'products': !exists(json, 'products') ? undefined : ((json['products'] as Array<any>).map(AdminGroupSaleListProductFromJSON)),
        'soldDate': !exists(json, 'soldDate') ? undefined : json['soldDate'],
        'soldPrice': json['soldPrice'],
        'status': AdminGroupSaleStatusFromJSON(json['status']),
        'updatedAt': json['updatedAt'],
    };
}

export function AdminGroupSaleListToJSON(value?: AdminGroupSaleList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'id': value.id,
        'marketplaces': !value.marketplaces ? undefined : ((value.marketplaces as Array<any>).map(AdminGroupSaleMarketplaceToJSON)),
        'name': value.name,
        'products': !value.products ? undefined : ((value.products as Array<any>).map(AdminGroupSaleListProductToJSON)),
        'soldDate': value.soldDate,
        'soldPrice': value.soldPrice,
        'status': AdminGroupSaleStatusToJSON(value.status),
        'updatedAt': value.updatedAt,
    };
}

